import { cn } from "@lib/util"
import React from "react"

const TpStar = ({ fillPercentage }) => (
  <svg
    className="h-8 w-8"
    viewBox="0 0 46 46"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        id={`starGradient-2${fillPercentage}`}
        x1="0%"
        y1="0%"
        x2="100%"
        y2="0%"
      >
        <stop offset={`${fillPercentage}%`} stopColor="#00b67a" />
        <stop offset={`${fillPercentage}%`} stopColor="#dcdce6" />
      </linearGradient>
    </defs>
    <g className="tp-star">
      <path
        className="tp-star__canvas"
        fill="#dcdce6"
        d="M0 46.330002h46.375586V0H0z"
      ></path>
      <path
        className="tp-star__canvas--half"
        fill={`url(#starGradient-2${fillPercentage})`}
        d="M0 46.330002h46.375586V0H0z"
      ></path>
      <path
        className="tp-star__shape"
        d="M39.533936 19.711433L13.230239 38.80065l3.838216-11.797827L7.02115 19.711433h12.418975l3.837417-11.798624 3.837418 11.798624h12.418975zM23.2785 31.510075l7.183595-1.509576 2.862114 8.800152L23.2785 31.510075z"
        fill="#FFF"
      ></path>
    </g>
  </svg>
)
const Star = ({ fillPercentage }) => (
  <svg
    width="24"
    height="21"
    viewBox="0 0 24 21"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        id={`starGradient${fillPercentage}`}
        x1="0%"
        y1="0%"
        x2="100%"
        y2="0%"
      >
        <stop offset={`${fillPercentage}%`} stopColor="#00B67A" />
        <stop offset={`${fillPercentage}%`} stopColor="#E0E0E0" />
      </linearGradient>
    </defs>

    {/* 完整的灰色星形 */}
    <path
      d="M11.3765 1.03064C11.553 0.539015 12.2483 0.539015 12.4248 1.03064L14.7183 7.4184C14.7977 7.63959 15.0074 7.78712 15.2425 7.78712H22.5365C23.0893 7.78712 23.3044 8.50564 22.8424 8.80937L17.0403 12.6242C16.8253 12.7655 16.7352 13.0356 16.8221 13.2777L19.0603 19.5115C19.241 20.0149 18.6771 20.4589 18.2302 20.165L12.2066 16.2046C12.0209 16.0825 11.7804 16.0825 11.5947 16.2046L5.57113 20.165C5.12416 20.4589 4.56026 20.0149 4.74102 19.5115L6.97922 13.2777C7.06615 13.0356 6.97596 12.7655 6.76103 12.6242L0.958873 8.80937C0.496925 8.50564 0.711975 7.78712 1.26483 7.78712H8.55885C8.79386 7.78712 9.00358 7.63959 9.083 7.4184L11.3765 1.03064Z"
      fill="#E0E0E0"
    />

    {/* 使用渐变填充的星形 */}
    <path
      d="M11.3765 1.03064C11.553 0.539015 12.2483 0.539015 12.4248 1.03064L14.7183 7.4184C14.7977 7.63959 15.0074 7.78712 15.2425 7.78712H22.5365C23.0893 7.78712 23.3044 8.50564 22.8424 8.80937L17.0403 12.6242C16.8253 12.7655 16.7352 13.0356 16.8221 13.2777L19.0603 19.5115C19.241 20.0149 18.6771 20.4589 18.2302 20.165L12.2066 16.2046C12.0209 16.0825 11.7804 16.0825 11.5947 16.2046L5.57113 20.165C5.12416 20.4589 4.56026 20.0149 4.74102 19.5115L6.97922 13.2777C7.06615 13.0356 6.97596 12.7655 6.76103 12.6242L0.958873 8.80937C0.496925 8.50564 0.711975 7.78712 1.26483 7.78712H8.55885C8.79386 7.78712 9.00358 7.63959 9.083 7.4184L11.3765 1.03064Z"
      fill={`url(#starGradient${fillPercentage})`}
    />
  </svg>
)

const CUSTOM_COMPONENTS = {
  "tp-star": TpStar,
  star: Star,
}
const renderCustomComponent = (tagName, attributes, fillPercentage, key) => {
  const Component = CUSTOM_COMPONENTS[tagName]
  if (!Component) {
    console.warn(`Unknown component: ${tagName}`)
    return (
      <Star
        key={`${key}+${tagName}`}
        fillPercentage={fillPercentage}
        {...attributes}
      />
    )
  }
  return (
    <Component
      key={`${key}+${tagName}`}
      {...attributes}
      fillPercentage={fillPercentage}
    />
  )
}

const StarRating = ({
  tagName = "star",
  rating,
  attributes = {},
  className = {},
}) => {
  const maxRating = 5
  const fullStars = Math.floor(rating)
  const partialFill = (rating % 1) * 100

  return (
    <div
      className={cn("flex w-full items-center justify-center gap-1", className)}
    >
      {[...Array(maxRating)].map((_, index) => {
        let fillPercentage = 0
        if (index < fullStars) {
          fillPercentage = 100
        } else if (index === fullStars) {
          fillPercentage = partialFill
        }
        return (
          <div key={index}>
            {renderCustomComponent(tagName, attributes, fillPercentage, index)}
          </div>
        )
      })}
    </div>
  )
}

export default StarRating
